import { Injectable } from "@angular/core";
import { ExaminerSlotSelection } from "../models/examiner-slot-selection.model";
import { AppMetaData, CheckRideApplicantTypeAllItems, CheckRideExaminerTypeAllItems, CheckRideOwnershipTypeAllItems, CheckRideRequestEntity, CheckRideRequestPaymentPartyAllItems, CheckRideRequestPaymentPartyEntity, CheckRideRequestSubStatusAllItems, CheckRideWorkflowAllItems, FlightSchoolApplicantEntity, SchoolFeatureAllItems } from "../../../meta-data/app-meta-data.service";
import { ExaminerRepositoryService } from "../../examiner/services/examiner-repository.service";
import { ExaminerBookingVariableContext } from "../models/examiner-booking-variable-context.model";
import { deepCopy } from "@devwareapps/devware-cap";
import { CheckRideCreationRefData } from "../models/checkride-creation-ref-data.model";
import { CheckRideRequestEntityExt } from "../../../meta-data/extensions/check-ride-request-entity.model";
import { CheckrideRefItem } from "../models/checkride-ref-item.model";
import { SchoolRepositoryService } from "../../schools/services/school-repository.service";
import { Observable } from "rxjs";
import { ValidateSchoolCheckridesRequest } from "../../schools/models/validate-school-checkrides-request.model";
import { map } from "rxjs/operators";
import { SchoolCheckrideUtilService } from "../../schools/services/school-checkride-util.service";

@Injectable({ providedIn: 'root' })
export class ScheduleMultipleBookingUtilService {

    constructor(private examinerRepositoryService: ExaminerRepositoryService,
        private schoolRepositoryService: SchoolRepositoryService,
         private schoolCheckrideUtilService: SchoolCheckrideUtilService,
    ) { }

    createCheckrideBookings(selections: ExaminerSlotSelection[], refData: CheckRideCreationRefData): CheckrideRefItem[] {
        const checkrides: CheckrideRefItem[] = [];

        let index = 0;
        for (const selection of selections) {
            const applicant = refData.applicants[index];

            if (applicant == null) {
                continue;
            }

            const checkride = this.createCheckrideBooking(selection, applicant, refData);

            checkrides.push(checkride);

            index++;
        }

        return checkrides;
    }


    validateCheckrideBookings(checkrides: CheckrideRefItem[]): Observable<CheckrideRefItem[]> {
        const checkride = checkrides[0].checkride;

        const request: ValidateSchoolCheckridesRequest = {
            checkRideGroupId: checkride.CheckRideGroupId,
            checkRideTypeId: checkride.CheckRideTypeId,
            flightSchoolApplicantIds: checkrides.map(c => c.applicantSelection.FlightSchoolApplicantId),
        };

        return this.schoolRepositoryService.validateSchoolCheckrides(request)
            .pipe(map(validationResult => {

                if (!validationResult.IsSuccess) {
                    console.error('Error validating checkrides: ' + validationResult.Message);
                }

                for (const applicantResult of validationResult.ApplicantResults) {
                    const checkrideRef = checkrides.find(c => c.applicantSelection.FlightSchoolApplicantId === applicantResult.FlightSchoolApplicantId);

                    if (checkrideRef) {
                        checkrideRef.validationResult = applicantResult;
                    }
                }

                return checkrides;
            }));
    }

    private createCheckrideBooking(selection: ExaminerSlotSelection, applicant: FlightSchoolApplicantEntity, refData: CheckRideCreationRefData): CheckrideRefItem {
        const applicantDataUpdate = this.schoolCheckrideUtilService.updateCheckrideApplicantData(refData.referenceCheckRide, applicant);
        
        let checkride: CheckRideRequestEntityExt = {...deepCopy(refData.referenceCheckRide), ...applicantDataUpdate } as CheckRideRequestEntityExt;
        const checkrideRef: CheckrideRefItem = {
            checkride: checkride,
            examinerSlotSelection: selection,
            applicantSelection: applicant,
            
        };

        checkrideRef.airportInfo = refData.airportInfoList.find(airport => airport.AirportId === selection.searchResult.LocationDistancesAirportId);

        let timeMinutes = this.examinerRepositoryService.getCheckrideTimeMinutes(selection.searchResult, checkride.CheckRideTestTypeId);

        const result = selection.searchResult;

        checkride.CheckRideWorkflowId = CheckRideWorkflowAllItems.SchoolWorkflow;

        // checkride.FlightSchoolApplicantId = applicant.FlightSchoolApplicantId;
        // checkride.FlightSchoolOrganizationId = applicant.FlightSchoolOrganizationId;
        // checkride.FlightSchoolBranchId = applicant.FlightSchoolBranchId;
        // checkride.EndorsedAndCheckRideReady = applicant.IsEndorsed;
        // checkride.PilotCertificateNumber = applicant.PilotCertificateNumber;
        // checkride.CurrentPilotCertifiateTypeId = applicant.CurrentPilotCertificateTypeId;
        // checkride.StudentApplicantCitizenshipCountyId = applicant.CitizenshipCountryId;
        // checkride.FlightSchoolInstructorId = applicant.PrimaryFlightSchoolInstructorId;
        // checkride.AirplaneMakeModel = applicant.AirplaneMakeModal;
        // checkride.AuthorityPreCheckRideNumber = applicant.AuthorityPreCheckRideNumber;
        // checkride.StudentApplicantStateProvinceId = applicant.StateProvinceId;
        // checkride.ForeignPilotMeetsQualifications = applicant.ForeignPilotMeetsQualifications;
        // checkride.AuthorityApplicationNumber = applicant.AuthorityApplicationNumber;

        checkride.PilotCertificateNumber = 'none'; // applicant.PilotCertificateNumber; // TODO: Add field to applicant
        checkride.CheckRideOwnershipTypeId = CheckRideOwnershipTypeAllItems.FlightSchool;
        checkride.CheckRideApplicantTypeId = CheckRideApplicantTypeAllItems.FlightSchoolStudent;
        checkride.CheckRideExaminerTypeId = CheckRideExaminerTypeAllItems.Examiner;

        checkride.ScheduledPilotExaminerId = selection.searchResult.PilotExaminerId;

        checkride.ScheduledDateTime = selection.scheduleDateTime;
        checkride.ScheduledTimeMinutes = timeMinutes;
        checkride.ScheduledAirportId = result.LocationDistancesAirportId;
        checkride.ScheduledPreTimeMinutes = result.ScenarioPreTimeMinutes;
        checkride.ScheduledPostTimeMinutes = result.ScenarioPostTimeMinutes;
        checkride.ScheduledCheckRideScenarioId = result.ScenarioCheckRideScenarioId;
        checkride.ScheduledPilotExaminerLocationId = result.LocationDistancesPilotExaminerLocationId;
        checkride.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.PendingPayment;

        checkride.ScheduledCheckRideCost = this.examinerRepositoryService.getFullBookingCost(result, checkride.CheckRideTestTypeId, refData.variables); //result.CheckRideScenarioCheckRideCost || 0 + result.PilotExaminerLocationAdditionalLocationCost || 0;;
        checkride.AdditionalTravelCost = result.PilotExaminerLocationTravelCost;
        checkride.ExaminerBookingCost = result.CheckRideScenarioBookingCost;
        checkride.ExaminerToApplicantNotes = result.CheckRideScenarioRequiredDocumentNotes;

        checkride.PilexosBookingCost = this.examinerRepositoryService.getPilexosBookingCost(checkride.CheckRideTestTypeId, checkride.PilexosBookingCostPaymentPartyId, refData.checkRideRequestPaymentPartyList);

        if (refData.features.SchoolFeatures?.find(f => f == SchoolFeatureAllItems.SchoolBookingFeeFreeTrial)) {
            checkride.PilexosBookingCostPaymentPartyId = CheckRideRequestPaymentPartyAllItems.FlightSchool;
            checkride.PilexosBookingCost = 0;
            checkride.PilexosBookingPaymentAdded = true;
            checkride.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.PendingApproval;
        }

        return checkrideRef;
    }

}